import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';

import { useUpdateCustomLabel } from '~hooks/queries/custom-labels/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';

import DescriptionTextArea from './common/component/DescriptionTextArea';

interface TextAreaProps {
  id: number;
  name: string;
  description?: string;
  parentId: number | null;
}

export const CATEGORY_DESCRIPTION_MAX_LENGTH_INFO = '100자 까지만 입력할 수 있어요.';
export const CATEGORY_DESCRIPTION_MAX_LENGTH = 100;

const GroupLabelDescriptionTextArea: React.FC<TextAreaProps> = ({ name, id, description }) => {
  const { companyId } = useDemoAwareCompanyId();
  const { mutateAsync: updateCustomLabel, isLoading } = useUpdateCustomLabel();

  const onSave = async () => {
    const response = await updateCustomLabel({
      companyId,
      id,
      name,
      description: description ?? '',
    });

    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('계정 설명이 변경되었습니다.');
    } else {
      Toast.error('계정 설명 변경에 실패했습니다.');
    }
  };

  return <DescriptionTextArea description={description} isLoading={isLoading} onSave={onSave} />;
};

export default GroupLabelDescriptionTextArea;
